import type Employee from 'modules/employees/store/models/Employee'

import employeeGroups from './employeeGroups'

export const employeeEmployeeGroup = (employee: Employee) => {
  const employeeGroup = employeeGroups.find({
    id: employee.attributes.employee_group_id,
  })

  if (!employeeGroup) {
    throw Error(`Error finding employeeGroups with id = ${employee.attributes.employee_group_id}`)
  }

  return employeeGroup
}
